import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/pro-light-svg-icons'

import { Button, DashboardModule } from '@domain-group/suit-theme'

import { useFilters } from '@domain-group/react-hooks'

import useAgencyProviderPriceOverride from '@hooks/useAgencyProviderPriceOverride'
import useAgencyProviderPriceOverrides from '@hooks/useAgencyProviderPriceOverrides'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import defaultRequestOptions from '@sections/Admin/packs/SystemManager/defaultRequestOptions'

import PriceOverridesTable from './PriceOverridesTable'

const buildPageFilterFields = () => {
  const style = {
    marginBottom: 16,
  }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Title or ID',
    },
  ]
}
interface PriceOverridesProps {
  agencyId: number,
  providerId:number,
}

const PriceOverrides = (props: PriceOverridesProps) => {
  const { agencyId, providerId } = props

  const filterPayload = useFilters()
  const {
    pageFilters,
  } = filterPayload

  const agencyProviderPriceOverridesPayload = useAgencyProviderPriceOverrides({
    filters: {
      ...pageFilters,
      agency_id: agencyId,
      provider_id: providerId,
    },
    requestOptions: defaultRequestOptions.agencyProviderPriceOverride,
    performHttpRequests: !!providerId,
  })

  const {
    filteredAgencyProviderPriceOverrides,
    hasFilteredAgencyProviderPriceOverrides,
    loading,
  } = agencyProviderPriceOverridesPayload

  const {
    callbacks: {
      createOrEditAgencyProviderPriceOverride,
    },
  } = useAgencyProviderPriceOverride({ agency_id: agencyId, provider_id: providerId })

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={<DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Price Overrides"
    >
      <DashboardModuleFilters
        filterFields={buildPageFilterFields()}
        {...filterPayload}
      />

      <DashboardModule.ScrollableSection>
        {!hasFilteredAgencyProviderPriceOverrides && !loading && (
          <DashboardModule.BlankState>
            <DashboardModule.BlankState.Title>
              No Price Overrides present
            </DashboardModule.BlankState.Title>

            <DashboardModule.BlankState.Paragraph>
              Please adjust your filters or add price override.
            </DashboardModule.BlankState.Paragraph>
          </DashboardModule.BlankState>
        )}

        {hasFilteredAgencyProviderPriceOverrides
        && <PriceOverridesTable priceOverrides={filteredAgencyProviderPriceOverrides} /> }

        <DashboardModule.Footer
          boxProps={{ borderTop: !loading ? '1px solid' : 'none' }}
        >
          <DashboardModule.FooterRight>
            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faPlus} />}
              onClick={() => createOrEditAgencyProviderPriceOverride()}
              // @ts-expect-error TS2322
              size={['medium', 'small']}
              width={['100%', 'fit-content']}
            >
              Add Price Override
            </Button>
          </DashboardModule.FooterRight>
        </DashboardModule.Footer>
      </DashboardModule.ScrollableSection>
    </DashboardModule>
  )
}

export default PriceOverrides
